export const zippedExtension = '.zip,.rar,.7zip';
export const execExtension = '.exe';
